import {isEqual, omit} from 'lodash';

import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {AccountModel} from '../../../models/api/accountModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {AccountsActionsEnum} from './accountsActions';

const accountsUpdatedReducer = createResourcesUpdatedReducer(
  'accounts',
  (account) => account.id,
  mergeAccount,
);

export function accountsReducer(
  state: ResourceMap<AccountModel>,
  action: AppAction,
): ResourceMap<AccountModel> {
  switch (action.type) {
    // Data Group.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return accountsUpdatedReducer(state, action);

    case AccountsActionsEnum.ACCOUNT_DELETED:
      return omit(state, action.payload.accountId);

    case AccountsActionsEnum.ACCOUNT_THIRD_PARTY_LOGO_FAILED: {
      const account = state[action.payload.accountId];
      if (account) {
        return {
          ...state,
          [action.payload.accountId]: {
            ...account,
            shouldIgnoreThirdPartyLogo: true,
          },
        };
      }
      return state;
    }

    default:
      return state;
  }
}

function mergeAccount(existingAccount: AccountModel | undefined, updatedAccount: AccountModel): AccountModel {
  if (!existingAccount) {
    return updatedAccount;
  }

  if (isEqual(existingAccount, updatedAccount)) {
    return existingAccount;
  }

  return {
    ...updatedAccount,
    // Use the last local state for if we tried reaching out to the third-party to not try again if something is updated.
    shouldIgnoreThirdPartyLogo: existingAccount.shouldIgnoreThirdPartyLogo,
  };
}
